export default __webpack_public_path__ + "static/media/novedades.947296f6.png";